import React, { useState } from 'react';
import './ScheduleTab.css';

import { Heading, Session } from '../../../components';
import { schedule as sessionData } from '../../../constants'; // Import session data
import { groupSessionsByDate } from '../../../utils';



const ScheduleTab = () => {

  const schedule = groupSessionsByDate(sessionData); // Group sessions by date using the utility function
  const [activeTab, setActiveTab] = useState(0); // State to manage the active tab

  return (

    <section className="schedule">

      <Heading title={'Event Schedule'} subTitle={'Your Guide to the Event'} />

      {/* Tab Navigation */}
      <div className="tab-buttons">
        {schedule.map((day, index) => (
          <button
            key={index}
            className={`button ${activeTab === index ? 'active' : ''}`}
            onClick={() => setActiveTab(index)}
          >
            {day.day} {/* Auto-generated "Day 1", "Day 2" */}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tab-content">

        {/* Date at the top */}
        <div className="schedule-date">
          <h2>{schedule[activeTab].date}</h2>
        </div>

        {/* Sessions for the Active Tab */}
        {schedule[activeTab].sessions.map(session => (
          <Session key={session.id} session={session} />
        ))}

      </div>

    </section>

  );
};

export default ScheduleTab;
